import { jsonMember, jsonObject } from 'typedjson';
import { Id } from '@shared/types/id';

@jsonObject
export class MeResponse {
  @jsonMember readonly id!: Id;
  @jsonMember readonly email!: string;
}
